import { render, staticRenderFns } from "./QuickReplyTab.vue?vue&type=template&id=46c2ef07"
import script from "./QuickReplyTab.vue?vue&type=script&lang=js"
export * from "./QuickReplyTab.vue?vue&type=script&lang=js"
import style0 from "./QuickReplyTab.vue?vue&type=style&index=0&id=46c2ef07&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports